"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * logMsgBuilder to build a nicely formatted message
 */
exports.messageBuilder = (params) => {
    const { source, destination, outgoing, type, message, request, response, traceId } = params;
    const xrayTraceId = traceId ? `[${traceId}]` : '';
    const sourceDestination = source && destination ? `[${source}] -> [${destination}]` : '';
    const outgoingCall = outgoing ? '[outgoing]' : '';
    const typeCheck = type ? `[${type}]` : '';
    const requestCheck = request ? `[${request}]` : '';
    const responseCheck = response ? `[${response}]` : '';
    const str = `${sourceDestination} ${xrayTraceId} ${outgoingCall} ${typeCheck} [${message}] ${requestCheck} ${responseCheck}`;
    return str.replace(/  +/g, ' ');
};
//# sourceMappingURL=index.js.map